/**
 * v2.26.0, built 2026-03-02:12:03:38
 */

function n(n, t) {
  for (var r in t) n[r] = t[r];
  return n;
}
function createStore(t) {
  var r = [];
  function u(n) {
    for (var t = [], u = 0; u < r.length; u++) r[u] === n ? (n = null) : t.push(r[u]);
    r = t;
  }
  function e(u, e, f) {
    t = e ? u : n(n({}, t), u);
    for (var i = r, o = 0; o < i.length; o++) i[o](t, f);
  }
  return (
    (t = t || {}),
    {
      action: function (n) {
        function r(t) {
          e(t, !1, n);
        }
        return function () {
          for (var u = arguments, e = [t], f = 0; f < arguments.length; f++) e.push(u[f]);
          var i = n.apply(this, e);
          if (null != i) return i.then ? i.then(r) : r(i);
        };
      },
      setState: e,
      subscribe: function (n) {
        return (
          r.push(n),
          function () {
            u(n);
          }
        );
      },
      unsubscribe: u,
      getState: function () {
        return t;
      },
    }
  );
}

// @ts-ignore

const initialState = {
  configuration: {},
  user: {},
  locale: {
    languageCode: "en-US",
    path: "./",
    isoCurrencyCode: "USD",
    stringsOverride: {},
  },
  externalLinks: {
    userManual: "",
    lineOfSponsorship: "",
    customerMemberList: "",
    incomeCalculator: "",
    learnMore: {
      bronzeBuilder: "",
      bronzeFoundation: "",
      performancePlusElite: "",
      customerSalesIncentive: "",
      twoTimeCashIncentive: "",
      performanceDashboard: "",
      personalGroupGrowth: "",
      frontlineGrowth: "",
    },
  },
  businessInView: {
    aff: "",
    abo: "",
  },
  tour: {},
  tokens: {},
};

/**
 * the redux store that we can share between components; exports interface
 * Redux.createStore
 * @type {{getState(): {user:{token_type: string, access_token: string,
 * expires_in: number, refreshAt: user_context: string, uri: string, nonce:
 * number, state: string, abo: number, aff: number, partyId: number,
 * cacheDateInMs: number}, locale: {languageCode: string, path: string,
 * isoCurrencyCode: string, stringOverrides: object, market: string, },
 * configuration: {requestUrlBase: string, contentUrlBase: string,
 * apiAuthorizeURL: string, apiTokenURL: string,apiClientId: string,
 * redirectAfterAuthenticationUri: string,receiverUri: string,branchName:
 * string}, externalLinks: {userManual: string, lineOfSponsorship: string, customerMemberList:
 * string, incomeCalculator: string, learnMore: object,}, tour:{enable:
 * boolean, path: string,} }, dispatch(reducer): void, subscribe(state): void}}
 * store
 * @property {function} getState() Returns the current state tree of your
 * application. It is equal to the last value returned by the store's reducer.
 * @property {function} setState() Dispatches an action. This is the only way to
 * trigger a state change.
 * @property {function} subscribe() Adds a change listener. It will be called
 * any time an action is dispatched, and some part of the state tree may
 * potentially have changed. You may then call getState() to read the current
 * state tree inside the callback.
 */
const store = createStore(initialState);

/**
 * get a dynamic configuration from a remove server
 * @param {string} path path to GraphQL configuration service
 * @param {string} env environment to fetch configuration for
 * @param {string} market market to fetch configuration for
 */
async function fetchDynamicConfiguration(path, env, market) {
  const query = `query($env: String!, $market: String!){config(env:$env, market:$market) {config{masheryDomain, accApiUrl}}}`;
  const variables = { env, market };
  const resp = await fetch(path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query, variables }),
  });
  if (resp.ok) {
    const { data } = await resp.json();
    return data.config.config;
  }
  return "";
}

/**
 * get the configuration.json from a remote server
 * @param {string=} path path to the JSON file to load
 * @returns {Promise}
 * @async
 */
async function fetchConfiguration(path) {
  const get = await fetch(path || "configuration.json", {
    mode: "cors",
  });
  if (get.ok) {
    return get.json();
  }
  return "";
}

/**
 * Inject preconnect rules to our API origins to increase speed of resolve
 * @param {object} data
 * @param {string} data.lambdaUrlBase
 * @param {string} data.requestUrlBase
 * @param {string} data.graphQLUrlBase
 */
async function injectPreloadRules(data) {
  const fragment = document.createDocumentFragment();
  [data.lambdaUrlBase, data.requestUrlBase, data.graphQLUrlBase].forEach((href) => {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = href;
    fragment.appendChild(link);
  });
  document.head.appendChild(fragment);
}

/**
 * initialize the app configuration and set to store
 * @param {object} args destructed params
 * @param {string=} args.path path to the JSON file to load
 * @param {object} args.config api configuration object
 * @param {string} args.config.requestUrlBase
 * @param {string} args.config.contentUrlBase
 * @param {string} args.config.apiAuthorizeURL
 * @param {string} args.config.apiTokenURL
 * @param {string} args.config.apiClientId
 * @param {string} args.config.redirectAfterAuthenticationUri
 * @param {string} args.config.receiverUri
 * @param {string} args.config.branchName
 * @param {boolean=} args.fromRemote whether to load dynamic module and ask API
 * for configuration [don't fetch args.path] [requires args.fromRemotePath,
 * args.fromRemoteEnv, args.fromRemoteMarket], defaults to false
 * @param {string=} args.fromRemotePath path to dynamic configuration GraphQL
 * service
 * @param {string=} args.fromRemoteEnv which environment to pull config for
 * @param {string=} args.fromRemoteMarket which market to pull config for,
 * defaults to 'global'
 * @returns {Promise}
 * @export
 * @async
 */
async function initConfiguration({
  path = "",
  config = {},
  fromRemote = false,
  fromRemotePath = "",
  fromRemoteEnv = "",
  fromRemoteMarket = "global",
}) {
  if (fromRemote && (fromRemotePath === "" || fromRemoteEnv === "")) {
    throw new Error("[acc-boot] attempted to load dynamic configuration module without specifying path or environment");
  }
  let data = "";
  if (Object.entries(config).length === 0 && config.constructor === Object) {
    // Configuration not passed, go fetch it
    try {
      if (fromRemote) {
        data = await fetchDynamicConfiguration(fromRemotePath, fromRemoteEnv, fromRemoteMarket);
      } else {
        data = await fetchConfiguration(path);
      }
    } catch (error) {
      data = "";
    }
  } else {
    // we have config, shadow it for simplicity
    data = config;
  }
  if (data === "") {
    throw new Error(
      "[acc-boot] configuration was not defined during initialization. Please check your configuration.json path, api.config object definition, or api.fromRemote* parameters.",
    );
  }

  try {
    injectPreloadRules(data);
  } catch (error) {
    // best attempt, no fallback
  }

  store.setState({ configuration: data });
}

/**
 * Converts a URLSearchParams to a plain JS object
 * @param {URLSearchParams} urlParams
 * @return {object} urlParams as an object of keys to values
 */
function urlParamsToObj(urlParams) {
  const paramsObj = {};
  urlParams.forEach((value, key) => {
    paramsObj[key] = value;
  });
  return paramsObj;
}

/**
 * Cleans up AFF/ABO values in an object, namely by handling leading zeroes correctly and making sure the pieces are stored as strings.
 * @param {object} container object containing aff and abo values
 * @return {object} object sharing all keys with aff and abo cleaned up
 */
function cleanAffAbo(container) {
  // remove leading zero's
  const abo = parseInt(container.abo, 10).toString();
  // pad aff scope if missing leading zeros
  const aff = `${"0".repeat(3 - container.aff.toString().length)}${container.aff.toString()}`;
  return { ...container, abo, aff };
}

function setSessionStorageCompat({ scope = {}, data = {} }) {
  // required by old P2 GCC components; also used to calc refresh token
  // request time

  data.cacheDateInMS = Date.now().toString();

  // This mucks the object values into a double escaped value. This is
  // because if acc-boot is used to set the sessionStorage, old GCC auth
  // receiver components will fail to read the value properly. Note, this is
  // terrible on so many levels, but acc-boot cleans this out for normal
  // usage within the store
  //
  // The level of displeasure I have for this cannot be overstated
  const baseObject = JSON.stringify({ ...scope, ...data })
    .replace(/:"/g, ':"\\"')
    .replace(/",/g, '\\"",')
    .replace(/"}/g, '\\""}');

  // set the sessionStorage key
  sessionStorage.setItem("persist:userPersistence", baseObject);
}

/**
 * Stores OAUth information for retrieval down the pipeline
 */
function initOauth() {
  // based on the current behavior, we string from the hash, not the search
  const urlParams = new URLSearchParams(window.location.hash.substring(1));

  // do we have a token?
  if (urlParams.has("access_token")) {
    try {
      // convert the search params to an object
      const data = urlParamsToObj(urlParams);

      // Break up the scope param and reduce into a single object
      let scope = data.scope
        .split(" ")
        .map((item) => {
          let [key, value] = item.split("=");
          switch (key) {
            case "aboNum":
              key = "abo";
              break;
            case "salesPlanAff":
              key = "aff";
              break;
            default:
          }
          return { [key]: value };
        })
        .reduce((a, v) => Object.assign(a, v), {});

      // delete the string scope from the object
      delete data.scope;

      scope = cleanAffAbo(scope);

      setSessionStorageCompat({ scope, data });
    } catch (error) {
      throw new Error(error);
    }
  }
}

var parse = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  cleanAffAbo: cleanAffAbo,
  setSessionStorageCompat: setSessionStorageCompat,
  initOauth: initOauth,
});

/**
 * initializes the users credentials by checking for existing sessionStorage or
 * by using credentials that have been passed in
 * @param {object} args
 * @param {object} args.user the user object with bearer token and abo info
 * @param {string=} args.user.token_type
 * @param {string=} args.user.access_token
 * @param {number=} args.user.expires_in
 * @param {string=} args.user.user_context
 * @param {string=} args.user.uri
 * @param {number=} args.user.nonce
 * @param {string=} args.user.state
 * @param {number=} args.user.abo
 * @param {number=} args.user.aff
 * @param {number=} args.user.partyId
 * @param {number=} args.user.cacheDateInMs
 * @param {object} args.tokens
 * @param {object} args.tokens.wso2
 * @param {string} args.tokens.wso2.access_token
 * @param {string} args.tokens.wso2.scope
 * @param {string} args.tokens.wso2.id_token
 * @param {string} args.tokens.wso2.token_type
 * @param {number} args.tokens.wso2.expires_in
 */

// @ts-ignore
function initAuthentication({ user = {}, tokens = {} }) {
  // TODO: use token multi-store for basic auth data in user
  if (Object.entries(user).length !== 0) {
    const data = cleanAffAbo(user);
    store.setState({ user: data, tokens });
    setSessionStorageCompat({ data });
  } else {
    // TODO: handle tokens pass w/o user here
    try {
      // attempt to remove the double escape from legacy auth-receiver set
      // tokens
      const userSession = JSON.parse(sessionStorage.getItem("persist:userPersistence").replace(/\\"/g, ""));
      if (userSession) {
        store.setState({ user: cleanAffAbo(userSession) });
      }
    } catch (error) {
      // deliberately empty
    }
  }

  if (Object.entries(store.getState().user).length === 0);
}

/**
 * pulls the user access token for a request. If acc-boot is managing refresh
 * tokens, checks to see if the access token needs to be refreshed and
 * refreshes as necessary before returning
 */
async function getAccessToken() {
  let { user } = store.getState();
  if (user.refreshAt < Date.now()) {
    const { refreshAccessToken } = await Promise.resolve().then(function () {
      return manageRefresh;
    });
    await refreshAccessToken();
    ({ user } = store.getState());
  }
  return user.access_token;
}

/**
 * sets the current language in redux, fires an event
 * @param {object} args destructed params
 * @param {string} args.languageCode path to the JSON file to load
 * @emits CustomEvent('locale-updated')
 * @export
 * @async
 */
function setLocaleLanguageCode({ languageCode = "" }) {
  const locale = { ...store.getState().locale, languageCode };

  store.setState({ locale });

  document.dispatchEvent(
    new CustomEvent("locale-updated", {
      bubbles: true,
      composed: true,
      detail: {
        languageCode,
      },
    }),
  );
}

function getDefaultIsoCurrencyCode() {
  const isoCode = store.getState().locale.isoCurrencyCode;
  if (isoCode === "") {
    throw new Error(
      "[acc-boot] locale.isoCurrencyCode was not defined during initialization. Please revise your configuration object.",
    );
  }
  return isoCode;
}

/**
 * initialize the app configuration and set to store
 * @param {object} args destructed params
 * @param {string=} args.languageCode i18n lang code for matching
 * @param {string=} args.path base path to the JSON files for strings
 * @param {string=} args.isoCurrencyCode default ISO 4217 currency code for use
 * when not returned by MAGIC
 * @param {object=} args.stringsOverride hard pushed strings that should
 * override for a given language
 * @param {object=} args.market Market configuration from the ssoOrigin
 * @export
 * @async
 */
async function initLocale({ languageCode = "", path = "", isoCurrencyCode = "", stringsOverride = {}, market = "" }) {
  if (languageCode === "") {
    throw new Error(
      "[acc-boot] locale.languageCode was not defined during initialization. Please revise your configuration object.",
    );
  }
  if (isoCurrencyCode === "") {
    throw new Error(
      "[acc-boot] locale.isoCurrencyCode was not defined during initialization. Please revise your configuration object.",
    );
  }
  store.setState({
    locale: { languageCode, path, isoCurrencyCode, stringsOverride, market },
  });

  document.dispatchEvent(
    new CustomEvent("locale-updated", {
      bubbles: true,
      composed: true,
      detail: {
        languageCode,
      },
    }),
  );
}

/**
 * @typedef losGridLink
 * @property name
 * @property link
 */

/**
 * initialize the external links to use within components and set to store
 * @param {object} args destructed params
 * @param {string} args.userManual
 * @param {string} args.lineOfSponsorship
 * @param {string} args.customerMemberList
 * @param {string} args.incomeCalculator
 * @param {object} args.learnMore
 * @param {string} args.learnMore.bronzeBuilder
 * @param {string} args.learnMore.bronzeFoundation
 * @param {string} args.learnMore.performancePlusElite
 * @param {string} args.learnMore.customerSalesIncentive
 * @param {string} args.learnMore.performanceDashboard
 * @param {string} args.learnMore.personalGroupGrowth
 * @param {string} args.learnMore.frontlineGrowth
 * @param {string} args.learnMore.twoTimeCashIncentive
 * @param {losGridLink[]} args.losGrid
 * @export
 * @async
 */
async function initExternalLinks({
  userManual = "",
  lineOfSponsorship = "",
  customerMemberList = "",
  incomeCalculator = "",
  learnMore = {},
  losGrid = [],
}) {
  // We can't destructure this would losing learnMore, so we just generate the
  // default
  const defaultLearnMore = {
    bronzeBuilder: "",
    bronzeFoundation: "",
    performancePlusElite: "",
    customerSalesIncentive: "",
    twoTimeCashIncentive: "",
    performanceDashboard: "",
    personalGroupGrowth: "",
    frontlineGrowth: "",
  };
  const inner = { learnMore: { ...defaultLearnMore, ...learnMore } };
  store.setState({
    externalLinks: {
      userManual,
      lineOfSponsorship,
      customerMemberList,
      incomeCalculator,
      losGrid,
      ...inner,
    },
  });
}

/**
 * sets the current business in view in redux, fires an event
 * @param {object} args destructed params
 * @param {number} args.aff
 * @param {number} args.abo
 * @emits CustomEvent('business-in-view-updated')
 * @export
 * @async
 */
function updateBusinessInView({ aff = "", abo = "" }) {
  store.setState({ businessInView: { aff, abo } });

  document.dispatchEvent(
    new CustomEvent("business-in-view-updated", {
      bubbles: true,
      composed: true,
      detail: {
        aff,
        abo,
      },
    }),
  );
}

/**
 * initialize the business in view from user or config params
 * @param {object} args destructed params
 * @param {number=} args.aff
 * @param {number=} args.abo
 * @export
 * @async
 */
async function initBusinessInView({ aff = "", abo = "" }) {
  let aboIV;
  let affIV;
  if (abo === "") {
    aboIV = store.getState().user.abo;
    affIV = store.getState().user.aff;
  } else {
    aboIV = abo;
    affIV = aff;
  }
  store.setState({ businessInView: { aff: affIV, abo: aboIV } });
}

/**
 * initialize the formatters that can be used for random data fields
 * @param {object} defaultVal destructed params
 * @param {object} defaultVal.address
 * @param {string} defaultVal.address.string
 * @param {string} defaultVal.address.divider
 * @param {object} defaultVal.name
 * @param {string} defaultVal.name.string
 * @param {string} defaultVal.name.divider
 * @export
 * @async
 */
async function initFormatters({
  address = {
    string: "",
    divider: "",
  },
  name = {
    string: "",
    divider: "",
  },
}) {
  const defaults = {
    address: {
      string: "",
      divider: "",
    },
    name: {
      string: "",
      divider: "",
    },
  };

  const formatters = {
    address: { ...defaults.address, ...address },
    name: { ...defaults.name, ...name },
  };

  store.setState({
    formatters,
  });
}

/**
 * Initialization method for firing up various boot systems that components will
 * use for operation
 * @param {object} args destructed params object
 * @param {object} args.setup destructed params object for boot setup
 * @param {string=} args.setup.globalName Name of the globally accessible app
 * property, defaults to window.__accCorePlus
 * @param {boolean=}  args.setup.globalStore Whether or not to make redux store
 * globally accessible in window
 * @param {boolean=} args.setup.bypassLocaleInit setting to true prevents locale
 * from starting during init
 * @param {object} args.api destructed params object for api configuration
 * initialization
 * @param {string=} args.api.path Path to the configuration.json file, defaults
 * to ./configuration.json
 * @param {object} args.api.config Object with configuration details
 * @param {string} args.api.config.requestUrlBase
 * @param {string} args.api.config.contentUrlBase
 * @param {string} args.api.config.apiAuthorizeURL
 * @param {string} args.api.config.apiTokenURL
 * @param {string} args.api.config.apiClientId
 * @param {string} args.api.config.redirectAfterAuthenticationUri
 * @param {string} args.api.config.receiverUri
 * @param {string} args.api.config.branchName
 * @param {boolean=} args.api.fromRemote whether to load dynamic module and ask
 * API for configuration [don't fetch args.path]
 * [requires args.api.fromRemotePath, args.api.fromRemoteEnv,
 * args.api.fromRemoteMarket], defaults to false
 * @param {string=} args.api.fromRemotePath path to dynamic configuration
 * GraphQL service
 * @param {string=} args.api.fromRemoteEnv which environment to pull config for
 * @param {string=} args.api.fromRemoteMarket which market to pull config for
 * @param {object} args.user user auth object to use for API calls
 * @param {string=} args.user.token_type prefer using the tokens object
 * @param {string=} args.user.access_token prefer using the tokens object
 * @param {number=} args.user.expires_in prefer using the tokens object
 * @param {string=} args.user.user_context
 * @param {string=} args.user.uri
 * @param {number=} args.user.nonce
 * @param {string=} args.user.state
 * @param {number=} args.user.abo
 * @param {number=} args.user.aff
 * @param {number=} args.user.partyId
 * @param {number=} args.user.cacheDateInMs
 * @param {object} args.locale destructed param object for locale initialization
 * @param {string=} args.locale.languageCode standard language code that should
 * be used to load translations, defaults to EN-US
 * @param {string=} args.locale.path path to the location of translation content
 * json files in various language codes
 * @param {string=} args.locale.isoCurrencyCode default ISO 4217 currency code
 * for use when not returned by MAGIC
 * @param {object=} args.locale.stringsOverride Object containing strings to
 * override
 * @param {string=} args.locale.market Market configuration from the ssoOrigin
 * @param {object} args.oauth destructed param object for oauth session
 * initialization
 * @param {boolean=} args.oauth.parse whether or not to load the dynamic oauth
 * module to parse the url
 * @param {boolean=} args.oauth.manageRefresh whether or not to load the
 * dynamic module which manages refresh tokens
 * @param {string=} args.oauth.redirect if set, redirects to the url passed
 * @param {object} args.externalLinks links object to use for external hrefs
 * @param {string} args.externalLinks.lineOfSponsorship
 * @param {string} args.externalLinks.customerMemberList
 * @param {string} args.externalLinks.incomeCalculator
 * @param {object} args.externalLinks.learnMore
 * @param {string} args.externalLinks.learnMore.bronzeBuilder
 * @param {string} args.externalLinks.learnMore.bronzeFoundation
 * @param {string} args.externalLinks.learnMore.performancePlusElite
 * @param {string} args.externalLinks.learnMore.customerSalesIncentive
 * @param {string} args.externalLinks.learnMore.twoTimeCashIncentive
 * @param {string} args.externalLinks.learnMore.performanceDashboard
 * @param {string} args.externalLinks.learnMore.personalGroupGrowth
 * @param {string} args.externalLinks.learnMore.frontlineGrowth
 * @param {import('./externalLinks/index.js').losGridLink[]} args.externalLinks.losGrid
 * @param {object} args.businessInView set the business in view aff/abo
 * @param {number} args.businessInView.aff
 * @param {number} args.businessInView.abo
 * @param {object} args.formatters
 * @param {object} args.tokens
 * @param {object} args.tokens.wso2
 * @param {string} args.tokens.wso2.access_token
 * @param {string} args.tokens.wso2.scope
 * @param {string} args.tokens.wso2.id_token
 * @param {string} args.tokens.wso2.token_type
 * @param {number} args.tokens.wso2.expires_in
 * @async
 */
async function init({
  setup = {},
  user = {},
  api = {},
  locale = {},
  oauth = {},
  externalLinks = {},
  businessInView = {},
  formatters = {},
  tokens = {},
}) {
  if (oauth.parse) {
    const { initOauth } = await Promise.resolve().then(function () {
      return parse;
    });
    await initOauth();
  }

  if (!oauth.redirect) {
    await initConfiguration(api);
    // @ts-ignore
    await initAuthentication({ user, tokens });
    if (oauth.manageRefresh) {
      const { initRefreshTokenManager } = await Promise.resolve().then(function () {
        return manageRefresh;
      });
      initRefreshTokenManager();
    }
    if (!setup.bypassLocaleInit) {
      await initLocale(locale);
    }
    await initExternalLinks(externalLinks);
    await initBusinessInView(businessInView);
    await initFormatters(formatters);

    if (setup.globalStore) {
      const name = setup.globalName || "__accCorePlus";
      window[name] = {
        store,
      };
    }
  } else {
    document.location.href = oauth.redirect;
  }
}

// TODO: use token multi-store, only using the user object for compat
// This also looks like it doesn't use the legacy store at all.

/**
 * sets the refresh time for the user access token to 15 minutes before its
 * expiry
 */
function setUserRefreshAt() {
  const { user } = store.getState();

  const refreshAt = new Date(parseInt(user.cacheDateInMS));

  refreshAt.setSeconds(refreshAt.getSeconds() + parseInt(user.expires_in));
  refreshAt.setMinutes(refreshAt.getMinutes() - 15);
  const userWithRefreshAt = { ...user, refreshAt };
  store.setState({ user: userWithRefreshAt });
}

/**
 * sets up refresh token management. Essentially, this involves setting a
 * timestamp on the user object so fetches of the access token can fire the
 * refresh chain when close to that timestamp.
 */
function initRefreshTokenManager() {
  setUserRefreshAt();
}

/**
 * uses the refresh token to request a refresh of the user access token; gives
 * the user object new values if successful
 */
async function refreshAccessToken() {
  const {
    configuration: { apiClientId, requestUrlBase, apiTokenURL },
    user,

    user: { refresh_token },
  } = store.getState();
  const response = await fetch(`${requestUrlBase}${apiTokenURL}`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: `client_id=${apiClientId}&grant_type=refresh_token&refresh_token=${refresh_token}`,
  });
  if (response.ok) {
    const { access_token, token_type, expires_in, refresh_token } = await response.json();
    const cacheDateInMS = Date.now().toString();
    const newUser = {
      ...user,
      access_token,
      token_type,
      expires_in,
      refresh_token,
      cacheDateInMS,
    };
    store.setState({ user: newUser });
    setUserRefreshAt();
  }
}

var manageRefresh = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  initRefreshTokenManager: initRefreshTokenManager,
  refreshAccessToken: refreshAccessToken,
});

export { getAccessToken, getDefaultIsoCurrencyCode, init, setLocaleLanguageCode, store, updateBusinessInView };
